export default __webpack_public_path__ + "static/media/logo-text.1317d195.png";